import cat1 from "../assets/bag11.jpg";
import cat2 from "../assets/bag12.jpg";
import cat3 from "../assets/bag13.jpg";
import cat4 from "../assets/bag14.jpg";

const categories = {
  clothbags: {
    title: "Cloth Bags",
    banner: cat1,
    description:
      "Our eco-friendly Cotton Carry Bags are the perfect blend of sustainability, durability, and style.",
  },

  canvasbags: {
    title: "Canvas Bags",
    banner: cat2,
    description:
      "Carry your essentials in style with our premium Canvas tote bag – the perfect blend of durability, functionality, and eco-conscious fashion.",
  },

  promotionbags: {
    title: "Promotion Bags",
    banner: cat3,
    description:
      "Elevate your corporate gifting with our Canvas Corporate Gift Bags featuring a sleek design and customizable with your company logo. Perfect for impressing clients and employees.",
  },

  jutebag: {
    title: "Jute Bags",
    banner: cat4,
    description:
      "A colored jute bag is a combination of style, durability, and sustainability, making it a popular choice for conscious consumers looking for functional and eco-friendly accessories.",
  },
  customisedbags: {
    title: "Customised Bags",
    banner: cat4,
    description:
      "Premium Customised bags",
  },
};

export default categories;